// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"eb0c348e","706":"a5b3dfee"}[chunkId] + ".chunk.js";
};